import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

const useSocketConnnect = ({ path = '', query = {} }) => {
  const socketRef = useRef(null);

  useEffect(() => {
    // Khởi tạo socket
    const socket = io(`${process.env.REACT_APP_SOCKET_SERVER_URL}${path}`, {
      transports: ['websocket'], // Chỉ sử dụng WebSocket
      query: query,
      // maxReconnectAttempts: 5,
      reconnectTimeout: 10000,
      reconnectionDelay: 2000,
      withCredentials: true
      // transportOptions: {
      //   polling: {
      //     extraHeaders: {
      //       Authorization: `Bearer ${firebaseAuth.currentUser?.accessToken}`
      //     }
      //   }
      // }
    });

    // Lưu socket vào ref
    socketRef.current = socket;

    // Lắng nghe sự kiện kết nối thành công
    socket.on('connect', () => {
      console.log('useSocketBooking connected');
    });

    // Lắng nghe sự kiện ngắt kết nối

    socket.on('disconnect', (reason) => {
      if (socket.connected) {
        console.log('useSocketBooking disconnected:', reason);
      }
    });

    // Lắng nghe sự kiện kết nối thất bại sau số lần thử lại tối đa
    socket.on('reconnect_failed', () => {
      console.log('Reconnect attempts exceeded. Stopping listeners and disconnecting.');
      // Ngừng tất cả listener
      socket.removeAllListeners();
      // Ngắt kết nối hoàn toàn
      socket.disconnect();
    });

    // Lắng nghe lỗi kết nối để refresh token
    socket.on('connect_error', (error) => {
      console.log('useSocketBooking  connect_error. error', error);
      console.table(error);
    });

    // Cleanup khi unmount
    return () => {
      socket.disconnect(); // Ngắt kết nối socket
    };
  }, [path, query]); // Chỉ khởi chạy một lần khi component mount

  return socketRef;
};

export default useSocketConnnect;
